module.exports = "<router-outlet></router-outlet>\n<app-bottom-navigation></app-bottom-navigation>\n"